<template>
    <div class="fix-height">
    <div id="comboPieChart">
    </div>
    </div>
</template>
<script>
import { cloneDeep } from 'lodash';
import $ from 'jquery';
import * as d3 from 'd3v4';

export default {
  props: ['sbData', 'chart'],
  data() {
    return {
      isCombo: true,
    };
  },
  mounted() {
    this.drawChart();
    window.addEventListener('resize', this.drawChart);
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.drawChart);
  },
  methods: {
    drawChart() {
      const details = cloneDeep(this.sbData.projectStatusGraphData);
      const margin = {
        top: 0, right: 20, bottom: 0, left: 100,
      };
      let width = parseInt(d3.select('#comboPieChart').style('width'), 10) - margin.left - margin.right;
      let height = 150;
      let n = 2;
      const itemWidth = 85;
      const itemHeight = 10;
      const radius = Math.floor(Math.min(width, height) / 2);
      let segments = d3
        .arc()
        .innerRadius(0)
        .outerRadius(50)
        .padAngle(0)
        .padRadius(15);
      if (this.isCombo) {
        n = 3;
        height = 160;
        segments = d3
          .arc()
          .innerRadius(0)
          .outerRadius(60)
          .padAngle(0)
          .padRadius(15);
      }
      const windowInnerWidth = window.innerWidth;
      if (windowInnerWidth < 500) {
        width = 300;
        height = 160;
        segments = d3
          .arc()
          .innerRadius(0)
          .outerRadius(75)
          .padAngle(0)
          .padRadius(15);
        $('.single-height').css({ maxHeight: 'unset' });
      }
      $('#comboPieChart svg').remove();
      const svg = d3
        .select('#comboPieChart')
        .append('svg')
        .attr('width', '100%')
        .attr('height', '100%')
        .attr('viewBox', `${windowInnerWidth < 500 ? (-width / 2) - 40 : (-width / 2)} ${(-height / 2)} ${width} ${height}`)
        .attr('preserveAspectRatio', 'xMinYMin');
      const data = d3
        .pie()
        .sort(null)
        .value((d) => d.count)(details);
      details.forEach((d) => {
        const d2 = d;
        d2.enabled = true;
      });
      let sections = svg
        .append('g')
        .attr('transform', `translate(${[-radius - 25, 0]})`)
        .selectAll('path')
        .data(data);
      sections
        .enter()
        .append('path')
        .attr('d', segments)
        .attr('fill', (d) => d.data.color);
      const pie = d3
        .pie()
        .value((d) => d.count)
        .sort(null);
      pie(details).forEach((d) => {
        const s = segments.centroid(d);
        const x = s[0];
        const y = s[1];
        svg.append('text')
          .attr('text-anchor', 'middle').attr('alignment-baseline', 'middle')
          .attr('transform', `translate(${[x - radius - 25, y]})`)
          .attr('id', `arcs1${d.data.label.replace(/\s/g, '')}`)
          .style('fill', '#fff')
          .style('font-size', '10px')
          .text(d.data.count);
      });
      // Legends Placing and contents starts here.
      const legends = svg
        .append('g')
        // Legends positioning w.r.to chart will starts here
        .attr('transform', () => `translate(${radius - 60}, ${-(radius - 60)})`)
        .selectAll('.legends')
        .data(data);
      // Alignment of legends to x-axis or y-axis starts here
      const legend = legends
        .enter()
        .append('g')
        .classed('legends', true)
        .attr('transform', (d, i) => {
          if (details.length === 1) {
            return `translate(${radius - 25}, ${10})`;
          }
          if (details.length === 2) {
            return `translate(${0}, ${10 + (i * 10)})`;
          }
          return `translate(${(i % n) * itemWidth}, ${(Math.floor(i / n) * (itemHeight))})`;
        });
      // Alignment of legends to x-axis or y-axis ends here
      legend
        .append('circle')
        .attr('cx', 3)
        .attr('cy', (d, i) => 6 + (6 * i))
        .attr('r', 6)
        .attr('fill', (d) => d.data.color)
        .attr('id', (d) => `cir2${d.data.label.replace(/\s/g, '')}`)
        .on('click', (d) => {
          let label = { ...d.data };
          label = label.label;
          const rect = d3.select(`.fix-height #cir2${d.data.label.replace(/\s/g, '')}`);
          let enabled = true;
          const totalEnabled = d3.sum(
            details.map((detailsItem) => {
              if (detailsItem.enabled) {
                return 1;
              }
              return 0;
            }),
          );
          if (rect.attr('class') === 'disabled') {
            rect.attr('class', '');
            rect.style('fill', (fill) => fill.color);
            rect.style('stroke', '');
          } else {
            if (totalEnabled < 2) return;
            rect.attr('class', 'disabled');
            rect.style('fill', 'transparent');
            rect.style('stroke', 'gray');
            d3.select(`#arc${label}`).style('fill', 'transparent');
            enabled = false;
          }
          pie.value((values) => {
            const d1 = values;
            if (d1.label === label) d1.enabled = enabled;
            if (d1.enabled) {
              return d1.count;
            }
            return 0;
          });
          sections = svg.selectAll('path').data(pie(details));
          sections
            .transition()
            .duration(750)
            .attrTween('d', (dCurrentItem) => {
              const interpolate = d3.interpolate(this.current, dCurrentItem);
              this.current = interpolate(0);
              return (t) => segments(interpolate(t));
            });
          pie(details).forEach((dItem) => {
            const s = segments.centroid(dItem);
            const x = s[0];
            const y = s[1];
            $(`#arcs1${dItem.data.label.replace(/\s/g, '')}`).remove();
            svg.append('text')
              .attr('text-anchor', 'middle').attr('alignment-baseline', 'middle')
              .attr('transform', `translate(${[x, y]})`)
              .attr('id', `arcs1${dItem.data.label.replace(/\s/g, '')}`)
              .style('fill', '#fff')
              .style('font-size', '10px')
              .style('font-weight', '400')
              .text(dItem.data.enabled ? dItem.data.count : '');
          });
        });
      // Spacing between legend symbols and legend title starts here
      legend
        .append('text')
        .attr('x', 30)
        .attr('y', (d, i) => 16 + (i * 8))
        .style('font-size', '14px')
        .attr('fill', 'rgba(0, 0, 0, 0.7)')
        .attr('transform', () => `translate(${-12}, ${-7})`)
        .text((d) => d.data.label);
      // Spacing between legend symbols and legend title Ends here
    },
  },
};
</script>
<style scoped>
.fix-height {
  max-height: 220px;
}
</style>
